import React from "react";

import FormAvatar from "UI/Form/FormAvatar";

function KomitentAvatar() {
  return <FormAvatar ariaLabel="ponuda" icon_word="contact_phone" />;
}

export default KomitentAvatar;
